module.exports = __webpack_public_path__ + "static/logistics-tracking@2x-ea928146aafc6311dc9ff60a14939685.png";